import React, { useState, useEffect } from "react";
import { Alert, Result } from "antd";
import MainWrapper from "../components/MainWrapper";
import SpinerIndicator from "../components/SpinerIndicator";
import { useDispatch, useSelector } from "react-redux";
import getVerifyManualTransaction, {
  getVerifyManualTransactionFunc,
} from "../redux/actions/getVerifyManualTransaction";
import { Navigate, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import AlertMessageWrapper from "../components/AlertMessageWrapper";
import ButtonWrapper from "../components/ButtonWrapper";
import { Select } from "antd";
import CnyMethodTransactionInfoCard from "../components/CnyMethodTransactionInfoCard";

const { Option } = Select;

const CnyTransactionInfo = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState("th");
  const verifyManualTransactionState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { isLoading, error } = verifyManualTransactionState;

  const postQrInitManualState = useSelector(
    (state) => state.postQrInitManualReducer
  );
  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = postQrInitManualState;

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { modalShow, data } = warningModalState;

  useEffect(() => {
    const lng = localStorage.getItem("lng");
    if (lng) {
      setLang(lng);
    }
  }, [lang]);

  useEffect(() => {
    dispatch(getVerifyManualTransactionFunc(params.id, "cny"));
  }, []);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={error} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError == "Error: auto trx id is not valid or expired") {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={<AlertMessageWrapper message={"交易ID无效或已过期"} />}
          />
        </div>
      );
    } else if (
      qrInitError == "ConflictException: Qr Code status has been changed"
    ) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={<AlertMessageWrapper message={"QR码状态已更改"} />}
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="" style={{ height: "100vh" }}>
      {/* <WarningModal
        visible={modalShow}
        lang={lang}
        closeIcon={<span></span>}
        maskClosable={false}
        // centered={true}
        footer={null}
        bodyStyle={{ borderRadius: 10 }}
        width={370}
      /> */}
      <MainWrapper>
        {isLoading ? (
          <SpinerIndicator fontSize="50px" color="#fff" />
        ) : error || qrInitError ? (
          errorMessage()
        ) : (
          <CnyMethodTransactionInfoCard lang={lang} />
        )}
      </MainWrapper>
    </div>
  );
};

export default CnyTransactionInfo;
